// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import vuetify from '@/plugins/vuetify';
import Vuex from 'vuex';
import App from './App';
import router from './router';
import store from './store.js';
import './scss/base.scss';
import { translate, translateError } from './translation/native_translate.js';
import appConfig from '../config/app_config';
import MultiFiltersPlugin from '@/plugins/MultiFilters';
import { LoaderPlugin } from 'vue-google-login';
import Meta from 'vue-meta';

Vue.config.devtools = true;

Vue.use(Vuex);
Vue.use(Meta);
Vue.use(LoaderPlugin, {
  client_id: '819961578899-kgl1peh7ij93tgrat26v8tgou8gtj95h.apps.googleusercontent.com',
});
Vue.use(MultiFiltersPlugin);
Vue.config.productionTip = false;
Object.defineProperty(Vue.prototype, '$translate', { value: translate });
Object.defineProperty(Vue.prototype, '$translateError', { value: translateError });

if (!appConfig.DEBUG) {
  console = console || {};
  console.log = function () { };
  console.trace = function () { };
  console.groupCollapsed = function () { };
  console.groupEnd = function () { };
}

/* eslint-disable no-new */
class VueWrapper {
  constructor() {
    this.vue = new Vue({
      vuetify,
      router,
      store,
      components: { App },
      template: '<App/>',
      mounted() {
        // You'll need this for renderAfterDocumentEvent.
        document.dispatchEvent(new Event('render-event'));
      },
    });
  }
  fire(event, data = null) {
    this.vue.$emit(event, data);
  }

  listen(event, callback) {
    this.vue.$on(event, callback);
  }

  removeListener(event, callback) {
    this.vue.$off(event, callback);
  }

  getVue() {
    return this.vue;
  }
}
window.EventBus = new VueWrapper();

window.EventBus.getVue().$mount('#app');

// Solve the issue of JS not firing before prerender. Used together with prerender-spa-plugin
// document.addEventListener('DOMContentLoaded', () => {
//   window.EventBus.getVue().$mount('#app');
// })
